"use strict";

define('app/legacyupload/legacy.upload.controller',['rs/abstract.content.controller', 'app/legacyupload/legacy.upload.view', 'rs/models/upload', 'vertebrae'], function (AbstractContentController, LegacyUploadView, RSUploadModel, Vertebrae) {
  var LegacyUploadController = AbstractContentController.extend({
    contentName: 'legacy-upload-content abstract-content fixed-header off-white',
    properties: ['file', 'results', 'validation'],
    legacyRootURI: '/rs/api/form/study/legacy',
    getLegacyResultsDownloadLink: function getLegacyResultsDownloadLink() {
      return window.location.protocol + '//' + window.location.host + this.legacyRootURI + '/result';
    },
    getTemplateProperties: function getTemplateProperties() {
      return {
        downloadLink: this.getLegacyResultsDownloadLink()
      };
    },
    getResultProperties: function getResultProperties(submitted) {
      var data = this.getValidation();
      if (submitted) {
        data = this.getResults();
      }
      return [{
        description: submitted ? 'Records failed to be created.' : 'Records will fail to be created.',
        results: data.failure
      }, {
        description: submitted ? 'Records successfully updated.' : 'Records will be successfully updated.',
        results: data.update
      }, {
        description: submitted ? 'Records successfully created.' : 'Records will be successfully created.',
        results: data.success
      }];
    },
    requestUploadFile: function requestUploadFile(legacyOptions) {
      var options = {
        file: this.getFile(),
        url: this.legacyRootURI
      };
      return RSUploadModel.upload(options).bind(this).tap(function (results) {
        this.setResults(results);
        this.getView().showSuccessView();
      })["finally"](this.showLoading());
    },
    requestValidateFile: function requestValidateFile() {
      var options = {
        file: this.getFile(),
        url: this.legacyRootURI + '/validate'
      };
      return RSUploadModel.upload(options).bind(this).tap(function (validation) {
        this.setValidation(validation);
        this.getView().showResultsView();
      })["finally"](this.showLoading());
    },
    setupView: function setupView() {
      this.setView(new LegacyUploadView());
    },
    start: function start() {
      if (!this.hasAdminPermission()) {
        throw new Vertebrae.App.Errors.CannotRoute();
      }
      this.getView().render();
    },
    hasAdminPermission: function hasAdminPermission() {
      var user = this.getAppController().getUser(),
        username = String(user.getUserName()).toLowerCase();
      return username == 'cayuseadmin';
    }
  }, {});
  return LegacyUploadController;
});

